// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S15V","col":"styles_col__CwBAN"};